import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import * as animation from "@universityofmaryland/web-styles-library/animation";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import { parseSvgString } from "@universityofmaryland/web-utilities-library/media";
import { wrapTextNodeInSpan, extractIconElement } from "@universityofmaryland/web-utilities-library/dom";
import { external_link } from "@universityofmaryland/web-icons-library/controls";
import { email } from "@universityofmaryland/web-icons-library/communication";
import { document } from "@universityofmaryland/web-icons-library/files";
import { fearless } from "@universityofmaryland/web-icons-library/brand";
const createLinkIcon = (element, type) => {
  const existingIcon = extractIconElement({ element });
  const ICONS = {
    email,
    newWindow: external_link,
    document,
    fearless
  };
  if (existingIcon) {
    element.insertBefore(existingIcon, element.firstChild);
    return;
  }
  const href = element.getAttribute("href");
  const isExternalTab = element.getAttribute("target") === "_blank";
  const isDownload = element.getAttribute("download") !== null;
  const isMail = href?.includes("mailto:");
  const insertIcon = (element2, svg) => {
    const icon = parseSvgString(svg);
    if (icon) element2.insertBefore(icon, element2.firstChild);
  };
  if (isMail) {
    insertIcon(element, ICONS.email);
  } else if (isExternalTab) {
    insertIcon(element, ICONS.newWindow);
  } else if (isDownload) {
    insertIcon(element, ICONS.document);
  } else if (type === "secondary") {
    insertIcon(element, ICONS.fearless);
  }
};
const createPlainText = ({
  isThemeDark,
  isTypeSecondary,
  plainText
}) => {
  if (!plainText) return null;
  return new ElementBuilder(plainText).styled(
    typography.sans.compose("min", { theme: isThemeDark ? "dark" : "light" })
  ).withStyles({
    element: {
      textDecoration: "underline",
      ...isTypeSecondary && {
        marginLeft: `${token.spacing.lg}`,
        alignSelf: "baseline"
      }
    }
  }).build();
};
const createElement = (type, props) => {
  createLinkIcon(props.element, type);
  const size = props.isSizeLarge ? "large" : "normal";
  let styleObject;
  if (type === "primary") {
    styleObject = elementStyles.action.primary.composePrimary({ size });
  } else if (type === "secondary") {
    let color = "default";
    if (props.isThemeGold) {
      color = "gold";
    } else if (props.isThemeDark) {
      color = "white";
    }
    styleObject = {
      ...elementStyles.action.secondary.composeSecondary({
        size,
        color
      }),
      ...animation.line.slideUnderRed
    };
  } else if (type === "outline") {
    const color = props.isThemeDark ? "white" : "default";
    styleObject = elementStyles.action.outline.composeOutline({ size, color });
  }
  const element = new ElementBuilder(props.element).styled(styleObject).withStylesIf(!!props.elementStyles, props.elementStyles || {});
  if (type === "secondary") {
    element.withModifier((el) => {
      wrapTextNodeInSpan(el);
    });
  }
  return element.build();
};
const primary = (props) => createElement("primary", props);
const secondary = (props) => createElement("secondary", props);
const outline = (props) => createElement("outline", props);
const options = (props) => {
  const { plainText, isTypePrimary, isTypeSecondary, isTypeOutline } = props;
  let actionModel;
  if (isTypePrimary) {
    actionModel = primary(props);
  } else if (isTypeSecondary) {
    actionModel = secondary(props);
  } else if (isTypeOutline) {
    actionModel = outline(props);
  }
  if (plainText) {
    const plainTextElement = createPlainText(props);
    if (plainTextElement) {
      return new ElementBuilder().styled(layout.grid.stacked).withStyles({
        element: {
          display: "grid",
          gap: token.spacing.sm,
          ["& > *"]: {
            marginBottom: "0 !important",
            ...!isTypeSecondary && { justifySelf: "center" }
          }
        }
      }).withChild(actionModel).withChild(plainTextElement).build();
    }
  }
  return new ElementBuilder().withChild(actionModel).build();
};
export {
  options,
  outline,
  primary,
  secondary
};
//# sourceMappingURL=text.js.map
